<template>
  <div class="no-login-menu">
    <ul class="menu-list">
      <li class="sign-group">
        <router-link class="btn-common btn-orange btnSubmit" :to="{ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register`, query: { back: $route.fullPath } }">{{ $t('admin.layout.header.login') }}</router-link>
      </li>
      <li><span>|</span></li>
      <li class="operation-flags">
          <div>
              <a class="flag-candidates" href="/jobseekers">
                  <span class="job_seekers">{{ $t('admin.layout.header.candidate') }}</span>
              </a>
              <a class="flag-employers" href="/">
                  <span class="employers">{{ $t('admin.layout.header.employer') }}</span>
              </a>
          </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ACCOUNT_TYPE } from '@/constant/common'

export default {
  data () {
    return {
      ACCOUNT_TYPE
    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}

</script>

<style lang='scss' scoped>
.no-login-menu {
  .menu-list {
    li {
      display: inline-block;
      padding: 0 8px;
      vertical-align: top;
      line-height: 29px;
    }
    .sign-group {
      background: #ff6633;
      color: #FFF;
      margin: 0 8px;
      padding: 0px;
      vertical-align: top;
      line-height: 29px;
      font-size: 12px;
      display: inline-block;
      a {
        padding: 0 15px;
        background-color: #ff6633;
        color: #fff;
        display: inline-block;
        height: 28px;
        line-height: 28px;
        margin: 0;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        cursor: pointer;
        text-decoration: none;
      }
    }

    .operation-flags {
      margin-top: -20px;
      padding: 0 8px;
      vertical-align: top;
      line-height: 29px;
      font-size: 12px;
      display: inline-block;

      .flag-candidates {
        display: inline-block;
        width: 90px;
        height: 96px;
        background-image: url(~@/assets/image/header/BG_badge.png);
        cursor: pointer;
        color: #0096cc;
        text-decoration: none;
        .job_seekers {
          display: inline-block;
          text-align: center;
          font-weight: bold;
          color: #FFF;
          width: 90px;
          margin-top: 30px;
          padding-top: 20px;
          background-repeat: no-repeat;
          background-position-x: 36px;
          background-image: url(~@/assets/image/header/ICON_JobSeeker.png);
        }
      }
    }

    .flag-employers {
      margin-left: 10px;
      display: inline-block;
      width: 90px;
      height: 96px;
      background-image: url(~@/assets/image/header/BG_badge.png);
      cursor: pointer;
      color: #0096cc;
      text-decoration: none;

      .employers {
        background-repeat: no-repeat;
        background-position-x: 36px;
        background-image: url(~@/assets/image/header/ICON_Employer.png);
        display: inline-block;
        text-align: center;
        font-weight: bold;
        color: #FFF;
        width: 90px;
        margin-top: 30px;
        padding-top: 20px;
      }
    }
  }
}
</style>
